import { SdsTooltipVariant } from '@superbet-group/web.lib.ui-components';
import { isMobileLayout } from '@superbet-group/web.lib.vue-utilities';
import { DirectiveOptions } from 'vue';
import {
    orientation,
    Orientation,
    TooltipDefinition,
} from './types';
import { useTooltipManager } from './TooltipManager';

export const sdsTooltipDirective: DirectiveOptions = {
    inserted(el: HTMLElement, binding: any) {
        const text = getTooltipText(binding.value);
        const variant = getVariant(binding.modifiers);
        const orientation = getOrientation(binding.modifiers);
        const isDesktopOnly = binding.modifiers?.desktop != null;
        const hotkeys = getHotkeys(binding.value);
        const isHtml = getIsHtml(binding.modifiers);
        const definition: TooltipDefinition = {
            text,
            variant,
            orientation,
            hotkeys,
            isHtml,
        };

        if (isDesktopOnly && isMobileLayout()) {
            return;
        }

        el.addEventListener('mouseenter', () => {
            useTooltipManager().setActiveTooltip(definition, el);
        }, { passive: true });

        el.addEventListener('mouseleave', () => {
            useTooltipManager().clearActiveTooltip();
        }, { passive: true });

        el.addEventListener('click', (event) => {
            useTooltipManager().toggleActiveTooltip(definition, el);

            if (!isMobileLayout()) {
                return;
            }

            event.stopPropagation();
        });
    },
};

function getVariant(modifiers: Record<string, boolean> = {}): SdsTooltipVariant {
    if (modifiers.primary) {
        return 'primary';
    } else if (modifiers.secondary) {
        return 'secondary';
    } else {
        return 'primary';
    }
}

function getIsHtml(modifiers: Record<string, boolean> = {}): boolean {
    return !!modifiers.html;
}

function getOrientation(modifiers: Record<string, boolean> = {}): Orientation {
    for (const facing of orientation) {
        if (modifiers[facing]) {
            return facing;
        }
    }

    return 'auto';
}

function getTooltipText(options: string | TooltipDirectiveConfig): string {
    if (typeof options === 'string') {
        return options;
    } else {
        return options.text;
    }
}

function getHotkeys(options: string | TooltipDirectiveConfig): string | undefined {
    if (typeof options === 'string') {
        return;
    }

    return options.hotkey;
}

type TooltipDirectiveConfig = {
    text: string;
    hotkey?: string;
};
